export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8869.70b0ecb5.jpg";